module.exports = __webpack_public_path__ + "media/images/companies/setouchi_dmo-bf1fa274c5c03e0a7bc79161bd323cc5.jpg";